// 倒计时
function getRandomNum(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

let endTimeG;

function cutDownTime() {
  let nowTime = new Date();
  let endTime = new Date(endTimeG);

  let leftTime = endTime.getTime() - nowTime.getTime();
  if (leftTime < 0) {
    setupNewCountdown();
    leftTime = 0;
  }
  let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
    leftM = Math.floor((leftTime / (1000 * 60)) % 60),
    leftS = Math.floor((leftTime / 1000) % 60);
  leftH = leftH >= 10 ? leftH : "0" + leftH;
  leftM = leftM >= 10 ? leftM : "0" + leftM;
  leftS = leftS >= 10 ? leftS : "0" + leftS;

  return {
    hour: leftH,
    minute: leftM,
    second: leftS,
  };
}
function setupNewCountdown() {
  const randomHour = getRandomNum(1, 9);
  const currentTime = new Date();
  endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
}
let intervalId;

function getCutDownTime() {
  setupNewCountdown();
  if (intervalId) clearInterval(intervalId);
  intervalId = setInterval(function () {
    let cutDownTimeText = cutDownTime();
    $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
    $(".sp_top_cut_down .sp_left_view .sp_minute").html(cutDownTimeText.minute);
    $(".sp_top_cut_down .sp_left_view .sp_second").html(cutDownTimeText.second);
  }, 1000);
}

getCutDownTime();

function mainRender() {
  $(function () {
    $("#root").css("zoom", "normal");
    let scale = document.body.clientWidth / 1080;
    $("#root").css("zoom", scale);

    window.addEventListener(
      "resize",
      (function () {
        var timer;
        return function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            let scale = document.body.clientWidth / 1080;
            $("#root").css("zoom", scale);
          }, 100);
        };
      })()
    );
  });

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
    const config = {
      rootMargin: "0px 0px 1300px 0px",
      threshold: 0,
    };

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target;
          const dataSrc = image.getAttribute("data-src");
          image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image); // 停止观察该图片
        }
      });
    },
      config);

    images.forEach(function (image) {
      lazyLoadObserver.observe(image); // 开始观察每个图片
    });
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      });
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  };

  let imgList = [
    'https://cdn.shopify.com/s/files/1/0736/3867/4663/files/20250827-s1.png',
    'https://cdn.shopify.com/s/files/1/0736/3867/4663/files/20250827-s2.png',
    'https://cdn.shopify.com/s/files/1/0736/3867/4663/files/20250827-s3.png',
    'https://cdn.shopify.com/s/files/1/0736/3867/4663/files/20250827-s4.png',
  ]
  let spImgList = [
    "https://cdn.shopify.com/s/files/1/0736/3867/4663/files/20250827-c1.png",
    "https://cdn.shopify.com/s/files/1/0736/3867/4663/files/20250827-c2.png",
    "https://cdn.shopify.com/s/files/1/0736/3867/4663/files/20250827-c3.png",
    "https://cdn.shopify.com/s/files/1/0736/3867/4663/files/20250827-c4.png",
  ];
  preloadImages(imgList);
  preloadImages(spImgList);

  document.addEventListener("DOMContentLoaded", function () {
    lazyLoadImages();

    new Swiper(".sp-swiper1", {
      autoplay: {
        disableOnInteraction: false,
        delay: 3500,
      },
      spaceBetween: 0,
      slidesPerView: "auto",
      centeredSlides: true,
      loop: true,
    });

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        window.scroll({
          top: offsetTop * $("div#root").css("zoom") - 240 * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });
  });

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isAndroid = /android/i.test(userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log("Android");
  } else if (isIOS) {
    console.log("iOS");
  } else if (isPC) {
    console.log("PC");
  } else {
    $(".sp_system").css("letter-spacing", "-4px");
  }

  $(".sp-select div").click(function () {
    $(this).addClass("active").siblings().removeClass("active");
    let index = $(this).index();
    $('.img-wrap1 img').attr('src', imgList[index]);
  });

  $(".option").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
  });

  $(".sp-choose").click(function () {
    $(".sp-mask").css("display", "flex");
    $(".sp-pop2").show();
    $(".sp-pop").show();
  });

  $(".sp-option").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");

    let colorOptions = $("#sp-color1 .sp-option.active").index();
    let colorOptions2 = $("#sp-color2 .sp-option.active").index();
    let colorOptions3 = $("#sp-color3 .sp-option.active").index();
    $("#spimg1")[0].src = spImgList[colorOptions];
    $("#spimg2")[0].src = spImgList[colorOptions2];
    $("#spimg3")[0].src = spImgList[colorOptions3];
  });

  let prods = window.product
  $('.sp-btn-style[data-num="1"]').click(function () {
    const color = $(this).siblings('.sp-select').find('div.active').attr('data-val');
    const size = $(this).siblings('.op-group').find('div.active').attr('data-val');
    const obj = prods.find(item => item.option1 == color && item.option2 == size)
    window.location.href = '/cart/' + obj.id + ':' + 1
  })
  $('.sp-btn-style[data-num="4"]').click(function () {
    const color = $(this).attr('data-val');
    const size = $(this).siblings('.op-group').find('div.active').attr('data-val');
    const obj = prods.find(item => item.option1 == color && item.option2 == size)
    window.location.href = '/cart/' + obj.id + ':' + 1
  })
  $('.sp-btn-style2').click(function () {
    const color1 = $(this).siblings('#sp-color1').find('div.active').attr('data-val');
    const color2 = $(this).siblings('#sp-color2').find('div.active').attr('data-val');
    const color3 = $(this).siblings('#sp-color3').find('div.active').attr('data-val');
    const size = $(this).siblings('#sp-size').find('div.active').attr('data-val');
    const product1 = prods.find(item => item.option1 == color1 && item.option2 == size)
    const product2 = prods.find(item => item.option1 == color2 && item.option2 == size)
    const product3 = prods.find(item => item.option1 == color3 && item.option2 == size)
    window.location.href = `/cart/${product1.id}:1,${product2.id}:1,${product3.id}:1`
  })

  $(".sp-pop2 .sp-close-btn").click(function (e) {
    $(".sp-mask").hide();
    $(".sp-pop2").hide();
  });

  $(".size-btn").click(function () {
    $(".sp-mask2").show();
    $(".sp-mask2 .sp-content").show();
  });

  $(".sp-mask2 .sp-close").click(function () {
    $(".sp-mask2").hide();
    $(".sp-mask2 .sp-content").hide();
  });

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName("gradually");
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll("span");
    const paragraph = gradually.querySelector(".sp-detail");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 检查是否在sp-part1下
            const isInPart1 = gradually.closest('.sp-part1') !== null;
            const animationDuration = isInPart1 ? '3s' : '0.5s';

            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade ${animationDuration} ease forwards`;
              span.style.animationDelay = `${index * 0.1}s`;

              const i = span.querySelector("i");
              if (i) {
                i.style.animation = `swift-up-fade ${animationDuration} ease forwards`;
                i.style.animationDelay = `${index * 0.1}s`;
              }
            });

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3;
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade ${animationDuration} ease forwards`;
              paragraph.style.animationDelay = `${totalDelay}s`;
            }

            observer.unobserve(gradually);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observer.observe(gradually);
  }



}

mainRender();